import API, { APIFile } from "../apiConfig";


const root = 'admin/dynamic-pages'

export default {
    // types api
    fetchTypes(){
        return API.get(`${root}/types`);
    },
    storeTypes(data){
        return API.post(`admin/dynamic-pages/types`, data)
    },
    updateTypes(id,data){
        return API.post(`${root}/types/${id}`, data)
    },
    // types api
    
    // pages api

    fetchPages (){
        return API.get(`${root}`);
    },
    storePages(data){
        return API.post(`${root}`,data);
    },
    updatePages(id,data){
        return API.post(`${root}/update/${id}`, data)
    }
}